import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div className="notfound-page">
    <h1>404</h1>
    <p>The page you are looking for could not be found.</p>
    <Link to="/login">Go back home</Link>
  </div>
);

export default NotFoundPage;
